'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_SealedTrait$Subtype(typeInfo, annotations, inheritedAnnotations, typeAnnotations, isObject, index, callByNeed, isType, asType) {
  this.wb = null;
  this.Kt = null;
  this.Ku = null;
  this.Ks = null;
  this.wb = typeInfo;
  this.Kt = callByNeed;
  this.Ku = isType;
  this.Ks = asType;
}
export { $c_Lmagnolia1_SealedTrait$Subtype as $c_Lmagnolia1_SealedTrait$Subtype };
$p = $c_Lmagnolia1_SealedTrait$Subtype.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_SealedTrait$Subtype;
/** @constructor */
function $h_Lmagnolia1_SealedTrait$Subtype() {
}
export { $h_Lmagnolia1_SealedTrait$Subtype as $h_Lmagnolia1_SealedTrait$Subtype };
$h_Lmagnolia1_SealedTrait$Subtype.prototype = $p;
$p.cr = (function(x, default$1) {
  return $j_java$002elang$002e$002dObject.$f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$p.rq = (function() {
  return this.Kt.lp();
});
$p.de = (function(t) {
  return (!(!this.Ku.j(t)));
});
$p.j = (function(t) {
  return this.Ks.j(t);
});
$p.b = (function() {
  return (("Subtype(" + this.wb.BB()) + ")");
});
$p.cq = (function(v1) {
  this.j(v1);
});
var $d_Lmagnolia1_SealedTrait$Subtype = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_SealedTrait$Subtype, "magnolia1.SealedTrait$Subtype", ({
  nT: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Lmagnolia1_SealedTrait$Subtype as $d_Lmagnolia1_SealedTrait$Subtype };
